import 'react-cmdk/dist/cmdk.css'

import { useState } from 'react'
import CommandPalette, { filterItems, getItemIndex, JsonStructureItem } from 'react-cmdk'
import { useSearchClassroomQuery } from '@Features/LandingPage/LandingPageApi/LandingPageApi'
import { logoutAction } from '@Features/Authentication/AuthenticationSlice/Authentication.slice'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '@Hooks/ReduxHooks'
import { useNavigate } from 'react-router'
import Spacer from '@Components/Utilities/Spacer'
import { Typography } from '@eduact/ed-system'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@eduact/student-theme'

type Props = {
	open: boolean
	onClose: (_: boolean) => void
}
export const Commands = (props: Props) => {
	const [search, setSearch] = useState('')
	const [page, setPage] = useState('root')
	const { data } = useSearchClassroomQuery({ searchQuery: search })
	const isAuth = useAppSelector(s => s.auth.isAuth)
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const [t, i18n] = useTranslation('layouts', { keyPrefix: 'command_bar' })
	const { setTheme, theme } = useTheme()

	const changeLanguage = () => {
		i18n.changeLanguage(i18n.language === 'ar-EG' ? 'en-GB' : 'ar-EG')
		if (i18n.language === 'ar-EG') {
			setTheme?.({ ...theme, direction: 'rtl' })
		} else {
			setTheme?.({ ...theme, direction: 'ltr' })
		}
	}

	const filteredItems = filterItems(
		[
			{
				id: 'search',
				heading: t('placeholder'),
				items: [
					{
						id: 'classrooms',
						icon: 'BookOpenIcon',
						children: t('find_a_classroom'),
						onClick: () => {
							setPage('classrooms')
						},
						closeOnSelect: false,
					},
				],
			},
			{
				id: 'dashboard',
				heading: 'Dashboard',
				items: [
					{
						id: 'dashboard_overview',
						icon: 'RectangleGroupIcon',
						children: t('dashboard'),
						onClick: () => {
							navigate('/dashboard')
						},
					},
					{
						id: 'profile',
						icon: 'UserCircleIcon',
						children: t('profile'),
						onClick: () => {
							navigate('/dashboard/profile')
						},
					},
					{
						id: 'settings',
						icon: 'CogIcon',
						children: t('settings'),
						onClick: () => {
							navigate('/dashboard/settings')
						},
					},
				],
			},
			{
				id: 'shortcuts',
				heading: t('shortcuts'),
				items: [
					{
						id: 'lang',
						icon: 'LanguageIcon',
						children: <Typography color="white">{t('language')}</Typography>,
						onClick: changeLanguage,
					},
				],
			},
		],
		search
	)

	const backAction: JsonStructureItem = {
		id: 'back',
		title: t('back'),

		children: (
			<Typography color="white" py="0.2rem">
				{t('back')}
			</Typography>
		),
		icon: i18n.language === 'ar-EG' ? 'ChevronRightIcon' : 'ChevronLeftIcon',
		showType: false,
		closeOnSelect: false,
		onClick: () => {
			setPage('root')
		},
	}

	return (
		<>
			<CommandPalette
			
				isOpen={props.open}
				onChangeOpen={() => {
					props.onClose(false)
					setPage('root')
				}}
				onChangeSearch={setSearch}
				search={search}
				page={page}
				placeholder={`${t('placeholder')}...`}
				footer={
					<div>
						{isAuth && (
							<CommandPalette.ListItem
								index={0}
								onClick={() => {
									dispatch(logoutAction())
									navigate('/')
									props.onClose(false)
								}}
								showType={false}
							>
								<Spacer py="0.2rem">
									<Typography color={'white'}>{t('logout')}</Typography>
								</Spacer>
							</CommandPalette.ListItem>
						)}
					</div>
				}
			>
				<CommandPalette.Page id="root">
					{filteredItems.map(item => (
						<CommandPalette.List key={item.id} heading={item.heading}>
							{item.items.map(_item => (
								<CommandPalette.ListItem
									{..._item}
									key={_item.id}
									index={getItemIndex(filteredItems, _item.id)}
									title={_item.title}
									showType={false}
								>
									{_item.children}
								</CommandPalette.ListItem>
							))}
						</CommandPalette.List>
					))}
				</CommandPalette.Page>
				<CommandPalette.Page id="classrooms" onEscape={() => setPage('root')}>
					<CommandPalette.List>
						<CommandPalette.ListItem index={0} {...backAction} />
						{data?.data.map((item, index) => (
							<CommandPalette.ListItem
								key={item.id}
								index={index + 1}
								showType={false}
								onClick={() => {
									navigate(`/classroom/${item.label}`)
									props.onClose(false)
								}}
							>
								{item.title}
							</CommandPalette.ListItem>
						))}
					</CommandPalette.List>
				</CommandPalette.Page>
			</CommandPalette>
		</>
	)
}
